var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { separateNumbersAndText, joinNumbersAndText, removeEmptyItems, } from "./utils";
export var numberSeparator = function (_a) {
    var text = _a.text, _b = _a.fixed, fixed = _b === void 0 ? null : _b, _c = _a.separateMore, separateMore = _c === void 0 ? false : _c, _d = _a.symbol, symbol = _d === void 0 ? "," : _d, _e = _a.allowUselessZeros, allowUselessZeros = _e === void 0 ? true : _e;
    var _f = separateNumbersAndText(text), nonNumericParts = _f.nonNumericParts, numericParts = _f.numericParts, startWithNumber = _f.startWithNumber;
    var localNumeric = __spreadArray([], numericParts, true);
    for (var i = 0; i < localNumeric.length; i++) {
        var localNumber = "".concat(Number(localNumeric[i]));
        if (fixed !== null && fixed !== undefined) {
            localNumber = "".concat(Number(localNumber).toFixed(fixed));
        }
        if (!allowUselessZeros) {
            localNumber = "".concat(removeUselessZeros({
                number: localNumber,
                returnType: "string",
            }));
        }
        var parts = localNumber.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, symbol);
        if (separateMore && parts[1]) {
            parts[1] = parts[1].replace(/\B(?=(\d{3})+(?!\d))/g, symbol);
        }
        localNumeric[i] = parts.join(".");
    }
    var result = joinNumbersAndText(localNumeric, removeEmptyItems(nonNumericParts), startWithNumber);
    return result;
};
export var separateStringNumber = function (inputString) {
    var _a = separateNumbersAndText(inputString), numericParts = _a.numericParts, nonNumericParts = _a.nonNumericParts;
    var noneNumericPartsRemovedEmpty = removeEmptyItems(nonNumericParts);
    return {
        numericParts: numericParts,
        nonNumericParts: removeEmptyItems(noneNumericPartsRemovedEmpty),
    };
};
export var removeUselessZeros = function (_a) {
    var number = _a.number, _b = _a.returnType, returnType = _b === void 0 ? "string" : _b, _c = _a.acceptDecimal, acceptDecimal = _c === void 0 ? true : _c, _d = _a.fixed, fixed = _d === void 0 ? 3 : _d;
    var stringNumber = number.toString();
    if (stringNumber.length <= 2 && stringNumber.includes(".")) {
        return stringNumber;
    }
    var truncatedNumber = acceptDecimal ? +number : Math.trunc(+number);
    var toFixedString = truncatedNumber.toFixed(fixed).toString();
    var newAmount = parseFloat(toFixedString);
    var result = returnType === "string" ? String(newAmount) : newAmount;
    return result;
};
